import axios, { AxiosResponse } from "axios";
import React, { useState } from "react";
import styled from "styled-components";
import { User } from "../common/models/User";
import ImageUploadButton from "../components/Buttons/ImageUploadButton";
import SimpleButton from "../components/Buttons/SimpleButton";
import Column from "../components/Column/Column";
import RoundedProfilePic from "../components/Images/RoundedProfilePic";
import InputWithIcon from "../components/Inputs/InputWithIcon";
import InputWithLabel from "../components/InputWithLabel/InputWithLabel";
import Label from "../components/Label/Label";
import { Modal } from "../components/Modal/Modal";
import FullHeightRow from "../components/Row/FullHeightRow";
import TextAreaWithIcon from "../components/TextArea/TextAreaWithIcon";
import default_user_pic from "../imgs/default_user_pic.svg";
import upload_icon from "../imgs/upload.svg";
import user_edit_icon from "../imgs/user_edit_icon.svg";
import user_square from "../imgs/user_square.svg";
import CloseCircle from "../components/Buttons/CloseCircle";
import close_circle from '../imgs/close-circle.svg';


const ModalProfilePic = styled(RoundedProfilePic)`
  align-self: center;
  z-index: 2;
`;

const ModalBackgroundPic = styled.img`
  height: 20%;
  width: 100%;
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 20px 20px 0px 0px;
`;

interface EditProfileProps {
  user: User;
  toggleShow: (show: boolean) => void;
  show: boolean;
  theme: string;
}
const EditProfileInput = styled(InputWithLabel)`
  width: calc(100% - 75px);
  padding-right: 7%;
  @media screen and (min-width: 1750px) {
    padding-right: 4%;
  }
`;

const FullHeightRowModal = styled(FullHeightRow)`
  position: relative;
  width: 50%;
  min-height: 80vh;
  background: #000d30;
  border: 1px solid #ffffff90;
  border-radius: 20px;
`;
const LeftColumn = styled(Column)`
  align-items: center;
  padding-top: 25%;
  width: 80%;
  @media screen and (min-height: 800px) {
    padding-top: 0px;
  }
`;

const ProfilePicContainer = styled.div`
  z-index: 2;
  display: flex;
  margin-top: 5%;
`;

const UploadBackgroundPictureContainer = styled("label")`
  position: absolute;
  right: 2%;
  top: 13%;
  z-index: 3;
  border: ${(props) =>
    props.theme.themeType === "dark" ? "1px solid #fff" : "1px solid #01D4DA"};
  background: transparent;
  border-radius: 10px;
  color: ${(props) => (props.theme.themeType === "dark" ? "#fff" : "#01D4DA")};
  font-weight: 600;
  padding: 10px;
  &:active {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
  }
  &:hover {
    cursor: pointer;
  }

  @media screen and (min-height: 1080px) {
    top: 16%;
  }
`;

const SaveButton = styled(SimpleButton)`
  margin-top: 10%;
`;

export const EditProfileModal = React.forwardRef<
  HTMLDivElement,
  EditProfileProps
>((props, ref) => {
  const [selectedProfilePicFile, setSelectedProfilePicFile] = useState<File>();
  const [selectedBackgroundPicFile, setSelectedBackgroundPicFile] =
    useState<File>();
  const [modalProfilePic, setModalProfilePic] = useState(
    props.user.profile_pic_s3_link
  );
  const [modalBackgroundPic, setModalBackgroundPic] = useState(
    props.user.background_s3_link
  );

  const [description, setDescription] = useState(props.user.description);
  const [stageName, setStageName] = useState("");

  const onModalProfilePicChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedProfilePicFile(event.target.files[0]);
      setModalProfilePic(URL.createObjectURL(event.target.files[0]));
    }
  };

  const onBackgroundPicChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedBackgroundPicFile(event.target.files[0]);
      setModalBackgroundPic(URL.createObjectURL(event.target.files[0]));
    }
  };

  const onDescriptionChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setDescription(event.target.value);
  };

  const onSaveClick = async () => {
    const formData = new FormData();
    formData.append("wallet_address", props.user.wallet_address);
    formData.append("description", description);
    if (stageName !== "") {
      formData.append("stage_name", stageName);
    }
    if (selectedProfilePicFile) {
      formData.append("profile_pic", selectedProfilePicFile);
    }
    if (selectedBackgroundPicFile) {
      formData.append("background_pic", selectedBackgroundPicFile);
    }
        axios
      .post(process.env.REACT_APP_BACKEND_URL + "/update_user", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response: AxiosResponse) => {
        props.toggleShow(false);
      });
  };

  const onStageNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setStageName(event.target.value);
  };

  return (
    <Modal ref={ref} show={props.show}>
      <FullHeightRowModal>
          <CloseCircle onClick={() => {props.toggleShow(false)}} bg={close_circle} />
        <LeftColumn>
          <ProfilePicContainer>
            <ModalProfilePic
              bg={modalProfilePic === null ? default_user_pic : modalProfilePic}
            />

            <ImageUploadButton
              bg={upload_icon}
              onImageChange={onModalProfilePicChange}
              align={'end'}
              htmlFor="profilePic"
            />
          </ProfilePicContainer>

          {/* <ModalBackgroundPic src={modalBackgroundPic}></ModalBackgroundPic> */}
          {/* <UploadBackgroundPictureContainer>
            Upload Background picture
            <input
              style={{ display: "none" }}
              accept="image/*"
              id={"backgroundpic"}
              type="file"
              onChange={onBackgroundPicChange}
            />
          </UploadBackgroundPictureContainer> */}

          {props.user.stage_name !== null && (
            <EditProfileInput>
              <Label>Stage Name</Label>
              <InputWithIcon
                src={user_square}
                type="text"
                onChange={onStageNameChange}
                defaultValue={props.user.stage_name}
              />
            </EditProfileInput>
          )}
          <InputWithLabel>
            <Label>About</Label>
            <TextAreaWithIcon
              rows={10}
              cols={10}
              src={user_edit_icon}
              onChange={onDescriptionChange}
              defaultValue={description}
            />
          </InputWithLabel>
          {props.theme === "dark" ? (
            <SaveButton bg="primary" onClick={onSaveClick}>
              Save
            </SaveButton>
          ) : (
            <SimpleButton onClick={onSaveClick}>Save</SimpleButton>
          )}
        </LeftColumn>
      </FullHeightRowModal>
    </Modal>
  );
});
